import React, { FunctionComponent } from 'react'
import styles from './ProjectLineMobile.module.sass'
import { useRootSelector } from '../../../../../utils/hooks'
import { projectSelector } from '../../../../../utils/selectors'
import { pipe } from 'fp-ts/function'
import { parseDate, toDateString } from '../../../../../utils/date-utils'
import { UserIcon } from '../../../../data-components/elements/UserElement/UserElement'
import clsx from 'clsx'
import { EMPTY_PROJECT, projectStatusToColor } from '../../../../../responses/projects'
import { Link } from 'react-router-dom'
import { urlWithParams } from '../../../../../http/utils'
import { ROUTES } from '../../../../../http/routes'
import Ellipsis from '../../../../etc/Ellipsis/Ellipsis'
import SideMark from '../../../../etc/SideMark/SideMark'
import { Classes } from '../../../../../styles'
import { ProjectLineProps } from './props'

const ProjectLineMobile: FunctionComponent<ProjectLineProps> = props => {
    const project = useRootSelector(projectSelector(props.projectId)) ?? EMPTY_PROJECT

    return <>
        <div className={styles.line}>
            <SideMark color={projectStatusToColor(project.status_id)}/>
            {props.control}
            <div className={styles.brand}>{project.brand.title}</div>
            <Link to={urlWithParams({projectId: props.projectId})(ROUTES.PROJECT_DETAIL)} className={styles.name}>
                <span>{project.code}</span>
                <div className={styles.splitter}/>
                <Ellipsis>{project.short_name}</Ellipsis>
            </Link>
            <div className={styles.date}>{pipe(project.opened_at, parseDate, toDateString)}</div>
            <div className={clsx(styles.manager, Classes.touchTarget)}>
                <UserIcon user={project.manager}/>
            </div>
            <div className={clsx(styles.users, Classes.touchTarget)}>
            {
                project.users.length > 0 && <div
                    className={styles.icon}
                    onClick={() => props.onUsersClick?.(project.users ?? [])}
                >
                    +{project.users.length}
                </div>
            }
            </div>
        </div>
    </>
}

export default ProjectLineMobile